import Solution from "./solution";
import compare from "../../Utils/compare";

const testCases = [
  {
    str: "JavaScript",
    size: 2,
  },
  {
    str: "JavaScript",
  },
  {
    str: "JavaScript",
    size: 3,
  },
  {
    str: "JavaScript",
    size: 4,
  },
  {
    str: "JavaScript",
    size: 1,
  },
];

const test = (code) => {
  try {
    const updatedFunc = `${code.trim()}`;
    const output = new Function(updatedFunc);
    for (let test of testCases) {
      const { str, size } = test;
      let outcome1 = output()(str, size);
      let outcome2 = Solution(str, size);
      const result = compare(outcome1, outcome2);
      if (!result) {
        return {
          status: "failed",
          details: { input: test, output: outcome1, expected: outcome2 },
        };
      }
    }

    return { status: "success", details: {} };
  } catch (e) {
    return {
      status: "error",
      details: { message: `${e.name}: ${e.message}` },
    };
  }
};

export default test;
